import { LayoutSplashScreenProvider } from '@/_metronic/layout/core/_LayoutSplashScreenProvider';
import { LayoutSplashScreen } from '@/_metronic/layout/core/LayoutSplashScreen';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { I18nProvider } from '../_metronic/i18n/i18nProvider';
import { LayoutProvider } from '../_metronic/layout/core';
import { MasterInit } from '../_metronic/layout/MasterInit';
import { ThemeModeProvider } from '../_metronic/partials';
import { AbilityProvider } from './casl/AbilityContext';
import { VersionUpdateNotification } from './components/feedback/VersionUpdateNotification';
import { AuthInit } from './modules/auth/core/Auth';
import { NotificationsProvider } from './modules/notifications/core/NotificationsContext';
import { InterfaceAppearance } from './modules/interface-appearance/InterfaceAppearance';
import { InterfaceLayoutProvider } from './modules/interface-appearance/InterfaceLayoutProvider';

const App = () => {
  return (
    <>
      <VersionUpdateNotification checkInterval={60000} />
      <Suspense fallback={<LayoutSplashScreen />}>
        <LayoutSplashScreenProvider>
          <I18nProvider>
            <LayoutProvider>
              <ThemeModeProvider>
                <InterfaceLayoutProvider>
                  <InterfaceAppearance>
                    {(loadingApplication) => (
                      <AuthInit loadingApplication={loadingApplication}>
                        <AbilityProvider>
                          <NotificationsProvider>
                            <Outlet />
                            <MasterInit />
                          </NotificationsProvider>
                        </AbilityProvider>
                      </AuthInit>
                    )}
                  </InterfaceAppearance>
                </InterfaceLayoutProvider>
              </ThemeModeProvider>
            </LayoutProvider>
          </I18nProvider>
        </LayoutSplashScreenProvider>
      </Suspense>
    </>
  );
};

export { App };
